// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"06f9604a","225":"f6bbce36","493":"3ec4a286","539":"8342c993","540":"80a2293c","708":"db1b7c1a","746":"418359e1","886":"49b0a373","966":"ea91884d"}[chunkId] + ".chunk.css";
};